<div class="job-assigned-user-wrapper">
    <h4 class="job-detail-title">{{ 'Survey.SurveyJobPanel.Filter.AssignedTo' | translate }}</h4>
    <div class="job-assigned-user-content">
        <div class="assigned-user-info">
            <i class="icon_solid_user i24"></i>
            <span class="assigned-user-name">{{ assignedUserName }}</span>
        </div>
        <gsp-button *ngIf="canEdit" iconClass="icon_line_close i24" [buttonTooltip]="buttonTooltip" (action)="deleteAction()" />
    </div>
</div>
